// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__9tCCA","toBottom":"Navbar_toBottom__o8Yeo","title":"Navbar_title__h6VL1","linkContainer":"Navbar_linkContainer__HqFg+","toRight":"Navbar_toRight__iJWHb"};